// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'loyalty-rebate',
//   templateUrl: './loyalty-rebate.component.html',
//   styleUrls: ['./loyalty-rebate.component.scss']
// })
// export class LoyaltyRebateComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }


import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
    selector: 'loyalty-rebate'
})
export class LoyaltyRebateComponent extends UpgradeComponent {
    @Input() value: number;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('loyaltyRebate', elementRef, injector);
    }
}